import { LOCALES } from '@marketplace/i18n';

export const documentationI18n = {
  [LOCALES.ENG]: {
    documentationForm_mainTitle: 'Tutorials and Documentation',
    documentationForm_documentationTutorialTitle: '1 - Tutorial/Documentation',

    documentationForm_documentationName: 'Documentation Name',
    documentationForm_documentationURL: 'Documentation URL',
    documentationForm_supportDescription: 'Support Description',
    documentationForm_licenseURLTitle: 'Add EULA (End User License Agreements)',
    documentationForm_licenseURL: 'License URL',

    documentationForm_cancelButton: 'Cancel',
    documentationForm_saveButton: 'Save',
  },
};
